export const DEFAULT_SLATE_VALUE = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];
